import React, { useEffect, useState } from "react";

import GridContainer from "common/components/Grid/GridContainer.jsx";
import GridItem from "common/components/Grid/GridItem.jsx";
import FormLabel from "@material-ui/core/FormLabel";
import TextField from '@material-ui/core/TextField';

import Checkbox from '@material-ui/core/Checkbox';

import withStyles from "@material-ui/core/styles/withStyles";
import styles from "../../styles.js"
import ChangesDropdownComponent from "./ChangesDropdownComponent.jsx";
import PhoneInputComponent from "./PhoneInputComponent.jsx";

const PhoneComponent = props => {
    const { classes } = props;

    const changeOptions = ["Add new", "Replace current", "Other (please describe)"];

    const [isError, setError] = useState(false);
    const [phoneNumber, setPhoneNumber] = useState("");
    const [isPrimaryContact, setPrimaryContact] = useState(false);
    const [phoneName, setPhoneName] = useState("");
    const [changeDropdownValue, setChange] = useState(changeOptions[0]);
    const [toBeReplaced, setReplace] = useState("");

    useEffect(() => {
        getFullInfo()
    }, [isPrimaryContact, phoneName, changeDropdownValue, toBeReplaced, phoneNumber])

    let getFullInfo = () => {
        let fullInfo = ""

        switch(changeDropdownValue) {
            case "Add new":
                fullInfo = "Add new phone number:" + phoneNumber;
                break;
            case "Replace current":
                fullInfo = "Replace current phone number " + toBeReplaced + " with new number: " + phoneNumber;
                break;
            case "Other (please describe)":
                fullInfo = phoneNumber;
                break;
        }

        fullInfo = phoneName ? fullInfo + ", The name for this phone is: " + phoneName : fullInfo;
        fullInfo = isPrimaryContact ? fullInfo +  ", This is a primary contact" : fullInfo;
        
        props.handleChange("txtField", fullInfo, props.iteration, isError)
    }

    let handleDropdownChange = (changeValue, replaceValue) => {
        setChange(changeValue)
        setReplace(replaceValue)
        setPhoneNumber("")
    }

    let handlePhoneChange = (number, error) => {
        setError(error);
        setPhoneNumber(number);
    }
  
  return (
    <div>
        <ChangesDropdownComponent
            iteration={props.iteration}
            selectedValue={"phone"}
            userInfo={props.userInfo}
            selectDefaultValue={props.selectDefaultValue}
            changeOptions={changeOptions}
            handleDropdownChange={handleDropdownChange}
        />
        <PhoneInputComponent
            id={"txtId" + props.iteration}
            handlePhoneChange={handlePhoneChange}
            apiRegex={props.apiRegex}
            phoneInputText={"Please type new value"}
        />
        <GridContainer
            className={classes.containerLine}
            alignItems="center"
        >
            <GridItem xs={6}>
                <FormLabel className={classes.labelHorizontal}>
                    Name
                </FormLabel>
            </GridItem>
            <GridItem xs={6}>
                <TextField
                    label="Optional"
                    onChange={(event) => {
                            setPhoneName(event.target.value)
                        }
                    }
                    className={classes.txtField}/>
            </GridItem>
        </GridContainer>
        <GridContainer
            className={classes.containerLine}
            alignItems="center"
        >
            <GridItem xs={6}>
                <FormLabel className={classes.labelHorizontal}>
                    Primary contact number
                </FormLabel>
            </GridItem>
            <GridItem xs={6}>
                <Checkbox
                    checked={isPrimaryContact}
                    onChange={(event) => {
                            setPrimaryContact(isPrimaryContact ? false : true)
                        }
                    }
                />
            </GridItem>
        </GridContainer>
    </div>
  );
};

export default withStyles(styles)(PhoneComponent);
